export const SET_COOKIE_BANNER_HIDDEN = 'SET_COOKIE_BANNER_HIDDEN';
export const SET_COUNTRY_GEO = 'SET_COUNTRY_GEO';
export const SET_ENV_VARS = 'SET_ENV_VARS';
